/// <reference types="@rsbuild/core/types" />

const localBackends = import.meta.env.PUBLIC_LOCAL_BACKENDS === "true";
const backendDomain = localBackends ? "local.meisterplan.dev" : "meisterplan.in";

export const backendUrls = {
  testTurtle: `https://testturtle.${backendDomain}`,
  deployDuck: `https://deployduck.${backendDomain}`,
  platformPlatypus: `https://platypus.${backendDomain}`,
  onpremiseOx: `https://onpremiseox.${backendDomain}`,
  registryReindeer: localBackends ? "https://registryreindeer.local.meisterplan.dev" : "https://meisterplan.in",
};
